import { css } from '@/styled-system/css';

export const tourSpokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  overflow: 'auto',
});
